(function ($) {

  var customMapStyle = [
    {
      "featureType": "administrative",
      "elementType": "geometry",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    }];
  

  
  var createMap = function (coords, zoom) {
    var coordsParts = coords.split(",");
    if (typeof google !== "undefined") {
      var options = {
        zoom: zoom,
        mapTypeControl: false,
        fullscreenControl : false,
        streetViewControl: false,
        zoomControl:false,
        mapTypeControl:false,
        gestureHandling: "none",
        styles: customMapStyle, // Apply the custom map style
        center: new google.maps.LatLng(coordsParts[0], coordsParts[1]),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      };

      var map = new google.maps.Map(document.getElementById("map"), options);

      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(coordsParts[0], coordsParts[1]),
        icon: 'https://cdn.shopify.com/s/files/1/0813/2709/6110/files/map-marker-pin.svg?v=1697189597',
        map: map,
      });
    }
  };

  $(function () {
    $(".li", "#places").on("click", function () {
      var $li = $(this);
      $li.addClass("selected").siblings().removeClass("selected");
      createMap($li.data("coords"), $li.data("zoom"));
    });
    $(".li", "#places").eq(0).trigger("click");
  });

  $("#map-wrapper #store-search").on("keyup", function () {
    var v = $(this).val();
    //console.log("v", v);
    $("#places .li").addClass("hidden");
    if (v == "") {
      // console.log('v null');
      $("#places .li").removeClass("hidden");
      $("#places .li").eq(0).trigger("click");
    } else {
      // console.log("v", v);
      $("#places .li").removeClass("selected");
      $("#places .li").each(function () {
        if (v != "" && $(this).text().search(new RegExp(v, "gi")) != -1) {
          // console.log("this", $(this).text());
          $(this).removeClass("hidden");
        } else if (v != "" && $(this).text().search(v) != 1) {
          $(this).addClass("hidden");
        }
      });
      if (document.querySelectorAll("#places .li:not(.hidden)").length > 0) {
        $("#places .li:not(.hidden)").eq(0).trigger("click");
      }
    }
  });
})(jQuery);
